import { Box, IconButton, Stack, Tooltip } from "@mui/material";
import React from "react";
import FormatDateToTR from "../FormatData/FormatDate";
import FormatAmount from "../FormatData/FormatAmount";
import { PreviewDebts } from "../../Models/ReferenceCodes";
import { getRemoteText, getRemoteValue } from "../../Utils/firebase";
import { CreditStatus } from "../../Models/Credit";

interface Props {
  debt: PreviewDebts;
  /**
   * CRL-3241 custom bulk amount: the portion of this debt covered by the
   * entered amount (modal's "kısmi" row). Adds a highlighted row; the debt's
   * own totals stay untouched.
   */
  partialPayAmount?: number;
}
const PaymentDetailDebt = ({ debt, partialPayAmount }: Props) => {
  return (
    <Stack
      sx={{
        borderRadius: "16px",
        background: "#FFFFFF",
        border: "1px solid #E9EEF4",
      }}
    >
      <Box
        key={"header"}
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        padding={"16px 16px 0 16px"}
      >
        <img
          src={debt.shop.logoUrl}
          alt={debt.shop.name}
          style={{ objectFit: "cover", width: "22px", height: "22px" }}
        />
        <h2 className="text-[15px] lg:text-base font-semibold pl-4 content-center">
          {debt.shop.name} {getRemoteValue("spending_suffix")}
        </h2>
      </Box>
      <Box
        key={"body"}
        display={"flex"}
        flexDirection={"column"}
        gap={2}
        padding={"16px"}
      >
        <Stack flexDirection={"row"} justifyContent={"space-between"}>
          <div className="text-sm font-normal text-cardLabel">
            {getRemoteValue("transaction_number")}
          </div>
          <div className="text-sm font-medium text-cardValue">
            {debt.creditId}
          </div>
        </Stack>
        <Stack flexDirection={"row"} justifyContent={"space-between"}>
          <div className="text-sm font-norma text-cardLabel">
            {getRemoteValue("spending_date")}
          </div>
          <div className="text-sm font-medium text-cardValue">
            {FormatDateToTR(debt.createdAt)}
          </div>
        </Stack>
        <Stack flexDirection={"row"} justifyContent={"space-between"}>
          <div className="text-sm font-normal text-cardLabel">
            {getRemoteValue("debt_amount")}
          </div>
          <div className="text-sm font-medium text-cardValue">
            {FormatAmount(debt.amount)}
          </div>
        </Stack>
        <Stack flexDirection={"row"} justifyContent={"space-between"}>
          <div className="flex items-center">
            <div className="text-sm font-normal text-cardLabel">
              {getRemoteValue("service_fee")}
            </div>
          </div>
          <div className="text-sm font-medium text-cardValue">
            {FormatAmount(debt.discountedRemainingServiceFee)}
          </div>
        </Stack>
        {debt.totalRemainingLateAmount != 0 && (
          <Stack flexDirection={"row"} justifyContent={"space-between"}>
            <div className="flex items-center">
              <div className="text-sm font-normal text-cardLabel ">
                {getRemoteValue("price_delay")}
              </div>
            </div>
            <div className="text-sm font-medium text-cardValue">
              {FormatAmount(debt.totalRemainingLateAmount)}
            </div>
          </Stack>
        )}
        <Stack flexDirection={"row"} justifyContent={"space-between"}>
          <div className="flex items-center">
            <div className="text-m font-semibold text-cardValue ">
              {getRemoteValue("total_pay")}
              {debt.totalPaidAmount !== 0 &&
                debt.status !== CreditStatus.PAID && (
                  <Tooltip
                    enterTouchDelay={0}
                    placement="top-end"
                    title={`${getRemoteValue("your_spending")}${FormatAmount(
                      debt.totalPaidAmount
                    )} ${getRemoteValue("your_amount_paid_partial")}`}
                  >
                    <IconButton sx={{ p: 0, px: 1 }}>
                      <img
                        src={"/icons/info-icon.svg"}
                        style={{ color: "#74788D" }}
                        alt=""
                      />
                    </IconButton>
                  </Tooltip>
                )}
            </div>
          </div>
          <div className="text-md font-semibold text-cardValue">
            {FormatAmount(debt.remainingPaymentAmount)}
          </div>
        </Stack>
        {partialPayAmount !== undefined && (
          <Stack flexDirection={"row"} justifyContent={"space-between"}>
            <div className="text-m font-semibold text-cardValue">
              {getRemoteText("custom_pay_partial_label", "Şimdi ödenecek (kısmi)")}
            </div>
            <div className="text-md font-semibold text-cardValue">
              {FormatAmount(partialPayAmount)}
            </div>
          </Stack>
        )}
      </Box>
    </Stack>
  );
};

export default PaymentDetailDebt;
